"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
class PropertyChangeEvent {
    constructor() {
        this.Timestamp = new Date();
    }
}
exports.PropertyChangeEvent = PropertyChangeEvent;
class CallerInfo {
}
exports.CallerInfo = CallerInfo;
class MethodPropertyChangeEvent {
}
exports.MethodPropertyChangeEvent = MethodPropertyChangeEvent;
